import { findLoanStatusLabel } from '@pesto/utils';
import { format, parseISO } from 'date-fns';

const toStatusLabel = (status: string): string =>
  findLoanStatusLabel(status.toUpperCase()) ?? status.charAt(0).toUpperCase() + status.slice(1);

export const formatBoardedLabel = (status: string, originationDate?: string | null): string => {
  const label = toStatusLabel(status);

  if (!originationDate) return label;
  const parsed = parseISO(originationDate);

  if (Number.isNaN(parsed.getTime())) return label;

  return `${label} ${format(parsed, 'MMM d')}`;
};
